import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// IC FunFlow — Premium Resort Playful button system.
// Defaults are now rounded-full pills with a cyan→navy gradient, matching design_guidelines.json.
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-95 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-r from-[#00B4D8] to-[#0A3055] text-white shadow-brand-cyan hover:shadow-brand-cyan-lg hover:-translate-y-0.5",
        cta:
          "bg-gradient-to-r from-[#FB8500] to-[#FFB703] text-white shadow-brand-orange hover:-translate-y-0.5",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border-2 border-[#0A3055]/15 bg-white text-[#0A3055] hover:border-[#00B4D8]/50 hover:bg-slate-50",
        secondary:
          "bg-white text-[#0A3055] border-2 border-[#0A3055]/10 hover:border-[#00B4D8]/50 hover:bg-slate-50",
        ghost:
          "bg-transparent text-muted-foreground hover:bg-slate-100 hover:text-[#0A3055] rounded-full",
        link:
          "text-secondary underline-offset-4 hover:underline rounded-none",
      },
      size: {
        default: "h-10 px-6 py-2",
        sm: "h-8 px-4 text-xs",
        lg: "h-12 px-8 text-base",
        xl: "h-14 px-10 text-base",
        icon: "h-10 w-10 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
